import React, { useEffect, useState } from "react";
import { Button, Col, Row } from "reactstrap";
import SelectBox from "../../../components/SelectBox";
import { LoggedUserType, SelectOptionType } from "../../../models/GlobalModels";
import Multiselect from "multiselect-react-dropdown";
import MultiSelectDropdown from "../../../components/MultiSelectDropdown";
import Label from "../../../components/Label";
import {
  icvGetAllLevel5DataAPICall,
  icvGetAllLevel6DataAPICall,
  icvGetAllSeasonsDataAPICall,
  icvGetAllVillagesDataAPICall,
  icvGetCCEUsersApiCall,
  icvGetCropBySearchAPICall,
  icvGetDistrictsDataAPICall,
  icvGetMandalDataAPICall,
  icvGetStatesDataAPICall,
  icvGetYearDataAPICall,
  ICVSurveyorAssigne,
} from "../../../api/icvActivityAPI";
import { useDispatch, useSelector } from "react-redux";
import { FormUtils } from "../../../utils/FormUtils";
import { DEFAULT_OPTION } from "../../../utils/Constant";
import {
  handleICVGetCCEUsersDataSlice,
  handleICVGetDistrictDataSlice,
  handleICVGetLevel5DataSlice,
  handleICVGetLevel6DataSlice,
  handleICVGetMandalDataSlice,
  handleICVGetVillagesDataSlice,
  handleICVGetYearDataSlice,
} from "../../../redux/slices/icvActivitySlice";
import { toast } from "react-toastify";
import { loginSelector } from "../../../redux/slices/loginSlice";
import { filterOptionsByRole } from "../../../utils/Util";
import { ICVMasterFilterType } from "../../../models/ICVActivitiesModels";

interface CropVillage {
  value: any; // Replace `any` with the actual type of `value`
}

function ICVMasters() {
  const {
    storeICVGetStatesData,
    storeICVGetSeasonsData,
    storeICVGetYearData,
    storeICVGetDistrictData,
    storeICVGetMandalData,
    storeICVGetVillagesData,
    storeICVGetCCEUsersData,
    storeICVGetLevel5Data,
    storeICVGetLevel6Data,
  } = useSelector((state: any) => state.icvActivity);
  const [icvFilter, setIcvFilter] = useState<ICVMasterFilterType>({
    season: DEFAULT_OPTION,
    year: DEFAULT_OPTION,
    state: DEFAULT_OPTION,
    district: DEFAULT_OPTION,
    tehsil: DEFAULT_OPTION,
    revenueCircle: DEFAULT_OPTION,
    patwarName: DEFAULT_OPTION,
    cropVillage: [],
    surveyor: [],
  });

  const dispatch: any = useDispatch();
  const user: LoggedUserType = useSelector(loginSelector).user;
  const [selectedValues, setSelectedValues] = useState<string[]>();

  const onchangeDropdown = (label: string, event: any) => {
  

    switch (label) {
      case "season":
        setIcvFilter((prev) => ({
          ...prev,
          season: event || null,
        }));
        break;

      case "year":
        setIcvFilter((prev) => ({
          ...prev,
          year: event || null,
        }));
        break;

      case "state":
        dispatch(handleICVGetDistrictDataSlice({}));
        dispatch(handleICVGetMandalDataSlice({}));
        dispatch(handleICVGetVillagesDataSlice({}));
        dispatch(handleICVGetLevel5DataSlice({}));
        dispatch(handleICVGetLevel6DataSlice({}));
        dispatch(handleICVGetCCEUsersDataSlice({}));
        if (event) {
          dispatch(icvGetDistrictsDataAPICall(event.value));
          setIcvFilter((prev) => ({
            ...prev,
            state: { label: event.label, value: event.value },
            district: DEFAULT_OPTION,
            tehsil: DEFAULT_OPTION,
            revenueCircle: DEFAULT_OPTION,
            patwarName: DEFAULT_OPTION,
            cropVillage: [],
          }));
        } else {
          setIcvFilter((prev: any) => ({
            ...prev,
            state: null,
            district: DEFAULT_OPTION,
            tehsil: DEFAULT_OPTION,
            revenueCircle: DEFAULT_OPTION,
            patwarName: DEFAULT_OPTION,
            cropVillage: [],
          }));
        }
        break;

      case "district":
        dispatch(handleICVGetMandalDataSlice({}));
        dispatch(handleICVGetVillagesDataSlice({}));
        dispatch(handleICVGetLevel5DataSlice({}));
        dispatch(handleICVGetLevel6DataSlice({}));
        dispatch(handleICVGetCCEUsersDataSlice({}));
        if (event) {
          dispatch(
             icvGetMandalDataAPICall(icvFilter?.state?.value, event.value)
          );
            
          setIcvFilter((prev) => ({
            ...prev,
            district: { label: event.label, value: event.value },
            tehsil: DEFAULT_OPTION,
            revenueCircle: DEFAULT_OPTION,
            patwarName: DEFAULT_OPTION,
            cropVillage: [],
          }));
        } else {
          setIcvFilter((prev: any) => ({
            ...prev,
            district: null,
            tehsil: DEFAULT_OPTION,
            revenueCircle: DEFAULT_OPTION,
            patwarName: DEFAULT_OPTION,
            cropVillage: [],
          }));
        }
        break;

      case "tehsil":
        dispatch(handleICVGetVillagesDataSlice({}));
        dispatch(handleICVGetLevel5DataSlice({}));
        dispatch(handleICVGetLevel6DataSlice({}));
        if (event) {
          if (
            event.value
          ) {
            dispatch(
              icvGetAllVillagesDataAPICall(
                icvFilter?.state?.value,
                icvFilter?.district?.value,
                event.value
              )
            );
            dispatch(
              icvGetAllLevel5DataAPICall(
                icvFilter?.state?.value,
                icvFilter?.district?.value,
                event.value
              )
            );
          }
          setIcvFilter((prev) => ({
            ...prev,
            tehsil: { label: event.label, value: event.value },
            revenueCircle: DEFAULT_OPTION,
            patwarName: DEFAULT_OPTION,
            cropVillage: [],
          }));
        } else {
          setIcvFilter((prev: any) => ({
            ...prev,
            tehsil: null,
            revenueCircle: DEFAULT_OPTION,
            patwarName: DEFAULT_OPTION,
            cropVillage: [],
          }));
        }
        break;

      case "revenueCircle":
        dispatch(handleICVGetLevel6DataSlice({}));
        dispatch(handleICVGetVillagesDataSlice({}));
        if (event) {
          if (
            event.value
          ) {
            dispatch(
              icvGetAllLevel6DataAPICall(
                icvFilter?.state?.value,
                icvFilter?.district?.value,
                icvFilter?.tehsil?.value,
                event.value
              )
            );
            
            dispatch(
              icvGetAllVillagesDataAPICall(
                icvFilter?.state?.value,
                icvFilter?.district?.value,
                icvFilter?.tehsil?.value,
                event.value
              )
            );
          }
          setIcvFilter((prev) => ({
            ...prev,
            revenueCircle: { label: event.label, value: event.value },
            patwarName: DEFAULT_OPTION,
            cropVillage: [],
          }));
        } else {
          dispatch(
            icvGetAllVillagesDataAPICall(
              icvFilter?.state?.value,
              icvFilter?.district?.value,
              icvFilter?.tehsil?.value,
            )
          );
          setIcvFilter((prev:any) => ({
            ...prev,
            revenueCircle: null,
            patwarName: DEFAULT_OPTION,
            cropVillage: [],
          }));
        }
        break;

      case "patwarName":
        dispatch(handleICVGetVillagesDataSlice({}));
        if (event) {
          if (
            event.value
          ) {            
            dispatch(
              icvGetAllVillagesDataAPICall(
                icvFilter?.state?.value,
                icvFilter?.district?.value,
                icvFilter?.tehsil?.value,
                icvFilter?.revenueCircle?.value,
                event.value
              )
            );
          }
          setIcvFilter((prev) => ({
            ...prev,
            patwarName: { label: event.label, value: event.value },
            cropVillage: [],
          }));
        } else {
          dispatch(
            icvGetAllVillagesDataAPICall(
              icvFilter?.state?.value,
              icvFilter?.district?.value,
              icvFilter?.tehsil?.value,
              icvFilter?.revenueCircle?.value,
            )
          );
          setIcvFilter((prev) => ({
            ...prev,
            patwarName: DEFAULT_OPTION,
            cropVillage: [],
          }));
        }
        break;

      case "cropVillage":
        if (event) {
          setIcvFilter((prev) => ({
            ...prev,
            cropVillage: [],
          }));
        } else {
          setIcvFilter((prev) => ({
            ...prev,
            cropVillage: [],
          }));
          dispatch(handleICVGetCCEUsersDataSlice({}));
        }
        break;

      default:
        break;
    }
  };

  useEffect(() => {
    dispatch(icvGetStatesDataAPICall());
    dispatch(icvGetAllSeasonsDataAPICall());
    dispatch(icvGetYearDataAPICall());
  }, [dispatch]);

  const statesData = FormUtils.convertDataList(
    storeICVGetStatesData?.data ?? []
  );

  const seasonsData = FormUtils.convertDataList(
    storeICVGetSeasonsData?.data ?? []
  );
  const yearData = FormUtils.convertToDataListObject(
    storeICVGetYearData?.data ?? []
  );
  const districtData = FormUtils.convertDataList(
    storeICVGetDistrictData?.data ?? []
  );
  const mandalData = FormUtils.convertDataList(
    storeICVGetMandalData?.data ?? []
  );
  const level5Data = FormUtils.convertDataList(
    storeICVGetLevel5Data?.data ?? []
  );
  const level6Data = FormUtils.convertDataList(
    storeICVGetLevel6Data?.data ?? []
  );
  const villagesData = FormUtils.convertVillagesDataList(
    storeICVGetVillagesData?.data ?? []
  );

  const cceUsersData = FormUtils.convertCCEUserDataList(
    storeICVGetCCEUsersData?.data ?? []
  );  
 
  const handleReset = () => {
    // Dispatch the API call
    const validSurveyors = icvFilter?.surveyor?.filter((user: any) =>
      user.accessTo.includes("ICV")
    );

    if (validSurveyors?.length === 0) {
      // Show an error or prevent submission
      // alert("Cannot assign data. No surveyor has access to ICV.");
      toast.info("Please fill in all mandatory fields before submitting")
      return;
    }

    // Dispatch only with valid surveyors
    if(icvFilter?.cropVillage?.length !== 0 ){
      const selectedVillages: any = villagesData.filter((village: any) => {
        return icvFilter?.cropVillage.includes(village.value);
      })
      dispatch(
        ICVSurveyorAssigne(
          icvFilter?.season?.value,
          icvFilter?.year?.value,
          selectedVillages[0]?.kshemaStateId,
          selectedVillages[0]?.kshemaDistrictId,
          selectedVillages[0]?.kshemaMandalId,
          selectedVillages.map((village: any) => village.kshemaVillageId),
          validSurveyors?.map((user: any) => user?.value) // Pass only the label values of valid surveyors
        )
      );
      setIcvFilter({
        season: DEFAULT_OPTION,
        year: DEFAULT_OPTION,
        state: DEFAULT_OPTION,
        district: DEFAULT_OPTION,
        tehsil: DEFAULT_OPTION,
        revenueCircle: DEFAULT_OPTION,
        patwarName: DEFAULT_OPTION,
        cropVillage: [],
        surveyor: [],
      });
  }else{
    
  }
    
  };
  const handleSurveyorChange = (values: any) => {
   
    setIcvFilter((prev) => {
      return { ...prev, surveyor: values };
    });
  };
  const handleCropVillageChange = (values: any[]) => {
    if(values?.length > 0) {
      const selectedVillages: any = villagesData.filter((village: any) => {
        return values.includes(village.value);
      })
      
      dispatch(
        icvGetCCEUsersApiCall(
          selectedVillages[0]?.kshemaStateName,
          selectedVillages[0]?.kshemaDistrictName,
          selectedVillages[0]?.kshemaMandalName,
          "",
        )
      );
    }
    else {
      dispatch(handleICVGetCCEUsersDataSlice({}));
    }
     // Should log the selected values
    setIcvFilter((prev) => {
      return { ...prev, cropVillage: values };
    });
  };
  const isFormValid = () => {
    return (
      icvFilter?.season?.value &&
      icvFilter?.year?.value &&
      icvFilter?.state?.value &&
      icvFilter?.district?.value &&
      icvFilter?.tehsil?.value && 
      icvFilter?.cropVillage?.length > 0 &&
      icvFilter?.surveyor?.length>0
    );
  };
  useEffect(() => {
  // Verify updated state
  }, [icvFilter]);

  // Filter options based on user role and accessed states/districts
  const filteredStatesData = filterOptionsByRole(
    statesData,
    user?.roleId || 0,
    user?.accessedStates || [],
    [],
    'states'
  );
  const filteredDistrictData = filterOptionsByRole(
    districtData,
    user?.roleId || 0,
    [],
    user?.accessedDistricts || [],
    'districts'
  );

  return (
    <>
      <div className="filter-section">
        <Row>
          <Col xs={6} md={3}>
            <SelectBox
              label="Season"
              required={true}
              options={seasonsData}
              value={icvFilter?.season}
              className="css-select-bg"
              onChange={(value) => onchangeDropdown("season", value)}
            />
          </Col>
          <Col xs={6} md={3}>
            <SelectBox
              label="Year"
              required={true}
              options={yearData}
              value={icvFilter?.year}
              className="css-select-bg"
              onChange={(value) => onchangeDropdown("year", value)}
            />
          </Col>
          <Col xs={6} md={3}>
            <SelectBox
              label="State"
              required={true}
              options={filteredStatesData}
              value={icvFilter?.state}
              className="css-select-bg"
              onChange={(value) => onchangeDropdown("state", value)}
            />
          </Col>
          <Col xs={6} md={3}>
            <SelectBox
              label="District"
              required={true}
              options={filteredDistrictData}
              value={icvFilter?.district}
              className="css-select-bg"
              onChange={(value) => onchangeDropdown("district", value)}
            />
          </Col>
        </Row>
        <Row>
          <Col xs={6} md={3}>
            <SelectBox
              label="Tehsil/Block"
              required={true}
              options={mandalData}
              value={icvFilter?.tehsil}
              className="css-select-bg"
              onChange={(value) => onchangeDropdown("tehsil", value)}
            />
          </Col>
          <Col xs={6} md={3}>
            <SelectBox
              label="Revenue Circle"
              options={level5Data}
              value={icvFilter?.revenueCircle}
              className="css-select-bg"
              onChange={(value) => onchangeDropdown("revenueCircle", value)}
            />
          </Col>
          <Col xs={6} md={3}>
            <SelectBox
              label="Patwar Name"
              options={level6Data}
              value={icvFilter?.patwarName}
              className="css-select-bg"
              onChange={(value) => onchangeDropdown("patwarName", value)}
            />
          </Col>
          <Col xs={6} md={3}>
            <MultiSelectDropdown
              options={villagesData}
              label="Crop village"
              optional={true}
              value={icvFilter?.cropVillage}
              onChange={handleCropVillageChange}
            />
          </Col>
        </Row>
        <Row>
          <Col xs={12} md={6} lg={3}>
            <MultiSelectDropdown
              options={cceUsersData} // This includes accessTo now
              label="Surveyor to be assigned"
              optional={true}
              value={icvFilter?.surveyor.map((user: any) => user?.value)} // Map to values
              onChange={(selectedValues) => {
                // Match the selected values with the original objects
                const selectedUsers = cceUsersData.filter((user) =>
                  selectedValues.includes(user?.value)
                );
                handleSurveyorChange(selectedUsers);
              }}
            />
          </Col>
          <Col xs={6} md={9} className="d-flex justify-content-end align-items-center pt-1 mt-3">
            {user?.permissions?.includes('Assign-Surveyor') && 
              <Button
                variant="outline-primary"
                className="mx-0 cl-btn-outline-primary"
                onClick={handleReset}
                disabled={!isFormValid() || !user?.permissions?.includes('Assign-Surveyor')}
              >
                Submit
              </Button>
            }
          </Col>
        </Row>
      </div>
    </>
  );
}

export default ICVMasters;
